export default __webpack_public_path__ + "static/1069-4f886f027027546f9abde6acd5d26337.gif";